import React from "react";
import { BrowserRouter as Router, Routes, Route } from "react-router-dom";

import AdminHomeScreen from "./components/AdminHomeScreen";
import Home from "./components/Home";
import Add from "./components/Add";
import Edit from "./components/Edit";
import Navbar from "./components/Navbar";
import Footer from "./components/Footer";
import AboutUs from "./components/AboutUs";
import Marquee from "react-fast-marquee";
import CasinoReviewCriteria from "./components/CasinoReviewCriteria";
import Editorial from "./components/Editorial";
import PrivacyPolicy from "./components/PrivacyPolicy";
import ResponsibleGaming from "./components/ResponsibleGaming";
import ContactUs from "./components/ContactUs";

function App() {
  return (
    <Router>
      <div>
        <Marquee
          pauseOnHover
          speed={100}
          gradient={false}
          className="marquee-wrapper"
        >
          <span className="marquee-item">
            💰 Selamat Datang Ke Free Credit {new Date().getFullYear()}!
          </span>
          <span className="marquee-item">
            💰 Free Kredit Online Kasino Terkini di Malaysia
          </span>
          <span className="marquee-item">
            💰 Dapatkan Kredit Lebih Sekarang di{" "}
            <a
              href="https://heylink.me/freecredit2025/"
              target="_blank"
              rel="noopener noreferrer sponsored"
              className="marquee-link-text"
            >
              Sini
            </a>
            !
          </span>
        </Marquee>

        <Navbar />
        {/* Routes */}
        <Routes>
          <Route path="/" element={<Home />} />
          <Route path="/adminhomescreen" element={<AdminHomeScreen />} />
          <Route path="/aboutus" element={<AboutUs />} />
          <Route path="/casinoreview" element={<CasinoReviewCriteria />} />
          <Route path="/editorial" element={<Editorial />} />
          <Route path="/privacypolicy" element={<PrivacyPolicy />} />
          <Route path="/responsiblegaming" element={<ResponsibleGaming />} />
          <Route path="/contactus" element={<ContactUs />} />
          <Route path="/add" element={<Add />} />
          <Route path="/edit/:id" element={<Edit />} />
        </Routes>
      </div>
      <Footer />
    </Router>
  );
}

export default App;
